import React, { useState } from "react";

const TemplateCard = ({ src = "", srcWebm = "", srcMp4 = "", poster = "", onClick = null, className = "", isVideo = false }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`border border-gray-300 rounded-[10px] sm:rounded-[14px] md:rounded-[16px] lg:rounded-[18px] xl:rounded-[20px] overflow-hidden cursor-pointer transition-all duration-500 hover:shadow-2xl hover:shadow-ag-green/20 hover:border-ag-green/50 relative group ${className}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Video or Image with subtle zoom */}
      {isVideo ? (
        <video
          crossOrigin='anonymous'
          autoPlay
          muted
          loop
          playsInline
          poster={poster}
          className={`w-full h-full object-cover transition-transform duration-700 ${
            isHovered ? "scale-105" : "scale-100"
          }`}
        >
          {srcWebm && <source src={srcWebm} type="video/webm" />}
          {srcMp4 && <source src={srcMp4} type="video/mp4" />}
          {src && <source src={src} type="video/mp4" />}
          Your browser does not support the video tag.
        </video>
      ) : (
        <img
          crossOrigin='anonymous'
          src={src}
          alt=""
          className={`w-full h-full object-cover transition-transform duration-700 ${
            isHovered ? "scale-105" : "scale-100"
          }`}
        />
      )}
      
      {/* Shine effect overlay */}
      <div className={`absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full transition-transform duration-1000 ${
        isHovered ? "translate-x-full" : ""
      }`} />
      
      {/* Bottom gradient overlay */}
      <div className={`absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent transition-opacity duration-300 ${
        isHovered ? "opacity-100" : "opacity-0"
      }`} />
    </div>
  );
};

export default TemplateCard;
